import React from "react";
import styled from "styled-components";

import {
  Grid,
  Hidden,
  List,
  ListItemText,
  ListItem as MuiListItem
} from "@material-ui/core";

const Wrapper = styled.div`
  box-shadow: 0 0 14px 0 rgba(53,64,82,.05);
  padding: ${props => props.theme.spacing(1) / 4}px
    ${props => props.theme.spacing(4)}px;
  background: ${props => props.theme.palette.common.white};
  position: relative;
`;

const ListItem = styled(MuiListItem)`
  display: inline-block;
  width: auto;
  padding-left: ${props => props.theme.spacing(2)}px;
  padding-right: ${props => props.theme.spacing(2)}px;

  &,
  &:hover,
  &:active {
    color: #000;
  }
`;

function Footer() {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Hidden smDown>
          <Grid container item xs={12} md={6}>
            <List>
              {/* <ListItem component="a">
                <Grid>
                  <ListItemText primary="Support " />
                </Grid>
              </ListItem> */}
              <ListItem component="a">
                <Grid>
                  <ListItemText style={{ color: "#1565c0" }} primary="Công ty TNHH Hà Nội Nhanh - Hotline: 024 6655 8596 - Email: hanoinhanh.int@gmail.com" />
                </Grid>
              </ListItem>
              {/* <ListItem component="a" href="#">
                <ListItemText primary="Help Center" />
              </ListItem>
              <ListItem component="a" href="#">
                <ListItemText primary="Privacy" />
              </ListItem>
              <ListItem component="a" href="#">
                <ListItemText primary="Terms of Service" />
              </ListItem> */}
            </List>
          </Grid>
        </Hidden>
        <Grid container item xs={12} md={6} justify="flex-end">
          <List>
            <ListItem>
              {/* <ListItemText primary="© 2019 - HNN" /> */}
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
